import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';

import { TextInput } from 'components/ucl';

interface IFavoriteInput {
  errorMessage?: string;
  favoriteName?: string;
  onChange: (value: string) => void;
  testID?: string;
}

export const FavoriteInput: React.FC<IFavoriteInput> = ({
  errorMessage = '',
  favoriteName,
  onChange,
  testID,
}) => {
  const { formatMessage } = useIntl();
  const [favoriteErrorMessage, setFavoriteErrorMessage] = useState<string>(errorMessage);

  useEffect(() => {
    if (errorMessage !== '') {
      return setFavoriteErrorMessage(errorMessage);
    }
    setFavoriteErrorMessage('');
  }, [errorMessage]);

  return (
    <TextInput
      aria-label={favoriteErrorMessage ? favoriteErrorMessage : formatMessage({ id: 'orderName' })}
      errorMessage={favoriteErrorMessage}
      autoFocus
      onFocus={() => setFavoriteErrorMessage('')}
      testID={testID}
      label={formatMessage({ id: 'orderName' })}
      onChangeText={value => onChange(value)}
      required
      onBlur={() => {
        if (!favoriteName) {
          return setFavoriteErrorMessage(formatMessage({ id: 'saveFavoriteOrderNameError' }));
        }
      }}
      value={favoriteName || ''}
    />
  );
};
